import { http } from "../utils/http";
import { API_URL } from "../config/api";

export const listLearningCourses = () => http.get("/learning/courses");
export const getLearningCourse = (id) => http.get(`/learning/courses/${id}`);
export const createLearningCourse = (data) => http.post("/learning/courses", data);
export const updateLearningCourse = (id, data) => http.patch(`/learning/courses/${id}`, data);
export const saveLearningDraft = (id, data) => http.put(`/learning/courses/${id}/draft`, data);
export const publishLearningCourse = (id) => http.post(`/learning/courses/${id}/publish`, {});
export const archiveLearningCourse = (id) => http.post(`/learning/courses/${id}/archive`, {});
export const deleteLearningCourse = (id) => http.del(`/learning/courses/${id}`);
export const uploadLearningCourseMaterial = (courseId, file) => {
    const body = new FormData();
    body.append("file", file);
    return http.post(`/learning/courses/${courseId}/materials`, body);
};

export const listLearningAssignments = () => http.get("/learning/assignments");
export const createLearningAssignment = (data) => http.post("/learning/assignments", data);
export const extendLearningAssignment = (id, data) => http.post(`/learning/assignments/${id}/extend`, data);
export const revokeLearningAssignment = (id, data) => http.post(`/learning/assignments/${id}/revoke`, data);
export const regenerateLearningLink = (id, data) => http.post(`/learning/assignments/${id}/regenerate-link`, data);
export const addLearningAttempts = (id, data) => http.post(`/learning/assignments/${id}/extra-attempts`, data);
export const reviewLearningAttempt = (id, data) => http.post(`/learning/attempts/${id}/review`, data);
export const annulLearningAttempt = (id, data) => http.post(`/learning/attempts/${id}/annul`, data);

export const listLearningCandidates = () => http.get("/candidates?page=1&per_page=100");

export const getPublicLearning = (token) => http.get(`/public/learning/${encodeURIComponent(token)}`, { auth: false });
export const acceptPublicLearningNda = (token, data) => http.post(`/public/learning/${encodeURIComponent(token)}/nda`, data, { auth: false });
export const savePublicLearningDraft = (token, data) => http.put(`/public/learning/${encodeURIComponent(token)}/draft`, data, { auth: false });
export const submitPublicLearning = (token, data) => http.post(`/public/learning/${encodeURIComponent(token)}/submit`, data, { auth: false });

export const publicLearningMaterialUrl = (url) => {
    const value = String(url || "");
    if (!value || /^https?:\/\//i.test(value)) return value;
    return `${API_URL}${value.startsWith("/") ? value : `/${value}`}`;
};
